/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IOperationTheatre } from 'app/shared/model/operation-theatre.model';
import { IEquipmentIP } from 'app/shared/model/equipment-ip.model';

export interface IOperationTheatreEquipment {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  theatre?: IOperationTheatre | null;
  equipment?: IEquipmentIP | null;
}

export const defaultValue: Readonly<IOperationTheatreEquipment> = {
  active: false,
};
